import { render } from "./UpdateInfo.vue?vue&type=template&id=ac6e8f70&ts=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=ts"
export * from "./UpdateInfo.vue?vue&type=script&lang=ts"

import "./UpdateInfo.vue?vue&type=style&index=0&id=ac6e8f70&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__